<template>
  <div class="values-discovery">

    <Instructions
        v-if="showInstructions"
        :allValues
        :showInstructions
        :workStarted
        :remainder1
        :remainder2
        :remainder3
        :resultCount />

    <BulkElimination
        v-show="!showInstructions && workStarted && !bulkEliminationComplete"
        :allValues
        :remainder1
        :remainder2
        :remainder3
    />

    <PairwiseRanking
        v-if="bulkEliminationComplete"
        :items="remainingValues" />

    <TopValues
        v-if="assessmentComplete"
        :allValues
        :remainingValues
        :rankedValues
        :resultCount
        :assessmentComplete />

  </div>
</template>


<script>
// google search: pairwise comparison ranking vue.js example
import TopValues from "./TopValues.vue";
import PairwiseRanking from "./PairwiseRanking.vue";
import BulkElimination from "./BulkElimination.vue";
import Instructions from "./Instructions.vue";

export default {
  components: {Instructions, BulkElimination, TopValues, PairwiseRanking},
  data() {
    return {
      workStarted:             0,
      showInstructions:        true,
      remainder1:              40,
      remainder2:              20,
      remainder3:              10,
      bulkEliminationComplete: false,
      rankedValues:            {},
      resultCount:             10,
      remainingValues:         [],
      assessmentComplete:      false,
      allValues: window.fc_child_data ? (window.fc_child_data.core_values ? window.fc_child_data.core_values : []) : [],
    };
  },
  mounted() {
    this.remainingValues = this.allValues;
  },
}
</script>
